import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Alert, CircularProgress, Tabs, Tab, Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import ClientForm from '../components/clients/ClientForm';
import IntegrationStatus from '../components/dashboard/IntegrationStatus';

const ClientDetail = () => {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const { clientId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClient = async () => {
      try {
        const token = localStorage.getItem('token');
        
        const response = await axios.get(`/api/clients/${clientId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (response.data.status === 'success') {
          setClient(response.data.data.client);
        }
        
        setLoading(false);
      } catch (error) {
        console.error('Error fetching client:', error);
        setError('Erro ao carregar dados do cliente. Por favor, tente novamente.');
        setLoading(false);
        
        if (error.response && error.response.status === 401) {
          navigate('/login');
        }
      }
    };
    
    fetchClient();
  }, [clientId, navigate]);

  const handleSubmit = async (formData) => {
    setSubmitting(true);
    setError(null);
    
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.patch(`/api/clients/${clientId}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.status === 'success') {
        setClient(response.data.data.client);
        alert('Cliente atualizado com sucesso!');
      }
      
      setSubmitting(false);
    } catch (error) {
      console.error('Error updating client:', error);
      setError(error.response?.data?.message || 'Erro ao atualizar cliente. Por favor, tente novamente.');
      setSubmitting(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleAddIntegration = () => {
    navigate(`/clients/${clientId}/integrations/new`);
  };

  if (loading) {
    return (
      <Container sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
        <CircularProgress />
      </Container>
    );
  }

  if (!client) {
    return (
      <Container>
        <Alert severity="error">Cliente não encontrado</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        {client.name}
      </Typography>
      
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}
      
      <Box sx={{ mb: 3 }}>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="Detalhes" />
          <Tab label="Integrações" />
          <Tab label="Produtos" />
        </Tabs>
      </Box>
      
      {activeTab === 0 && (
        <ClientForm 
          client={client} 
          onSubmit={handleSubmit} 
          isSubmitting={submitting} 
        />
      )}
      
      {activeTab === 1 && (
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <Button 
              variant="contained" 
              onClick={handleAddIntegration}
            >
              Nova Integração
            </Button>
          </Box>
          <IntegrationStatus clientId={clientId} />
        </Box>
      )}
      
      {activeTab === 2 && (
        <Box>
          <Typography variant="h6">Produtos</Typography>
          <Typography>
            Funcionalidade em desenvolvimento
          </Typography>
        </Box>
      )}
    </Container>
  );
};

export default ClientDetail;
